import { createFileRoute, Link, Outlet, redirect, useLocation } from "@tanstack/react-router";
import { ScopeBar } from "@/components/scope-bar";
import { HelpButton } from "@/components/kb/help-button";

export const Route = createFileRoute("/_authenticated/app/inventory")({
  // Send the bare /app/inventory URL to the default tab before any UI
  // renders — saves a paint + client-side navigation round trip.
  beforeLoad: ({ location }) => {
    if (location.pathname === "/app/inventory" || location.pathname === "/app/inventory/") {
      throw redirect({ to: "/app/inventory/on-hand", replace: true });
    }
  },
  component: InventoryLayout,
});

const TABS = [
  { to: "/app/inventory/on-hand", label: "On-hand" },
  { to: "/app/inventory/state", label: "State" },
  { to: "/app/inventory/holds", label: "Holds & QC" },
  { to: "/app/inventory/low-stock", label: "Low Stock" },
  { to: "/app/inventory/movements", label: "Movements" },
  { to: "/app/inventory/skus", label: "SKUs" },
  { to: "/app/inventory/locations", label: "Locations" },
  { to: "/app/inventory/stranded", label: "Stranded" },
  { to: "/app/inventory/serials", label: "Serials" },
  { to: "/app/inventory/kits", label: "Kits" },
  { to: "/app/inventory/bundles", label: "Bundles" },
] as const;

function InventoryLayout() {
  const loc = useLocation();

  return (
    <div className="flex flex-col h-screen">
      <div className="border-b bg-card px-4 sm:px-6 pt-4 sm:pt-5">
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div className="min-w-0">
            <h1 className="text-xl sm:text-2xl font-semibold tracking-tight">Inventory</h1>
            <p className="text-sm text-muted-foreground mt-1 hidden sm:block">Catalog, locations, and on-hand quantities.</p>
          </div>
          <div className="flex items-center gap-2 flex-wrap"><ScopeBar /><HelpButton moduleKey="inventory" /></div>
        </div>
        <div className="mt-4 -mb-px -mx-4 sm:-mx-6 px-4 sm:px-6 overflow-x-auto scrollbar-none">
          <div className="flex gap-1 min-w-max">
            {TABS.map((t) => {
              const active = loc.pathname.startsWith(t.to);
              return (
                <Link
                  key={t.to}
                  to={t.to}
                  className={`px-3 sm:px-4 py-2 text-sm rounded-t-md border-b-2 transition-colors whitespace-nowrap ${
                    active ? "border-primary text-foreground font-medium" : "border-transparent text-muted-foreground hover:text-foreground"
                  }`}
                >
                  {t.label}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-auto"><Outlet /></div>
    </div>
  );
}